export const BreadcrumbsNavigationKeys = {
    healthPlan: 'Health Plan',
    addToPlan: 'Add to Plan',
    downloadApp: 'Download App',
    logIn: 'Log In'
};
